import { observer } from "mobx-react-lite";
import React from "react";

import { useWorkflow } from "../../workflow-context";

import RunButton from "@/components/ui/RunButton";

const RunWorkflow: React.FC = () => {
  const workflow = useWorkflow();
  const { isRunning, nodeCount, isStarted } = workflow;

  const disabled = nodeCount === 0;

  return (
    <RunButton
      run={() => {
        workflow.run();
      }}
      disabled={disabled}
      isRunning={isRunning || isStarted}
      tooltipSide="right"
      tooltipText={{
        idle: "Run Workflow",
        running: "Workflow is running",
      }}
    />
  );
};

export default observer(RunWorkflow);
